import { ReactNode } from 'react';
import styled from 'styled-components';
import BackLink, { BacklinkProps } from './BackLink';
import {
  ActionsContainer,
  DescriptionContainer,
  Root,
  PrimaryRow,
  SecondaryRow,
  TitleContainer,
  Container,
} from './Header.styled';

type HeaderProps = {
  /**
   * Props to pass to the Header's BackLink component. If none give, the BackLink won't be displayed.
   */
  backlinkProps?: BacklinkProps;
  /**
   * The content to display in the header title row.
   */
  titleRow: ReactNode;
  /**
   * Horizontal content displayed between the title and actions.
   */
  description?: ReactNode;
  /**
   * Header actions (usually Button components).
   */
  actions?: ReactNode;
  /**
   * A component to display in the header's second row.
   */
  secondaryRow?: ReactNode;
  /**
   * Whether the header should take up the full width of the screen.
   */
  fullWidth?: boolean;
};

const Header = ({
  titleRow,
  backlinkProps,
  description,
  actions,
  secondaryRow,
  fullWidth,
}: HeaderProps) => {
  return (
    <Root data-appcues="page-header">
      <Container
        $backlinkProps={backlinkProps}
        $secondaryRow={secondaryRow}
        $fullWidth={fullWidth}
      >
        <PrimaryRow>
          {/* eslint-disable-next-line @appcues/jsx-props-no-spreading */}
          {backlinkProps && <BackLink {...backlinkProps} />}
          <TitleContainer data-appcues="page-title">{titleRow}</TitleContainer>
          {description && (
            <DescriptionContainer>{description}</DescriptionContainer>
          )}
          <ActionsContainer data-appcues="page-actions">
            {actions}
          </ActionsContainer>
        </PrimaryRow>
        {secondaryRow && <SecondaryRow>{secondaryRow}</SecondaryRow>}
      </Container>
    </Root>
  );
};

export default styled(Header)``;
